'use strict';require('../../style/css');
require('../../icon/style/css');
require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/button/style/css.web.js
// module id = 205
// module chunks = 0